import { getGlobalObject } from '../tools/globalObject';
export function getEventBridge() {
    const eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getCapabilities() {
            return JSON.parse(eventBridgeGlobal.getCapabilities?.() || '[]');
        },
        getPrivacyLevel() {
            return eventBridgeGlobal.getPrivacyLevel?.();
        },
        getIsTraceSampled() {
            return JSON.parse(eventBridgeGlobal.getIsTraceSampled?.() || 'null');
        },
        getAllowedWebViewHosts() {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send(eventType, event, viewId) {
            const view = viewId ? { id: viewId } : undefined;
            eventBridgeGlobal.send(JSON.stringify({ eventType, event, view }));
        },
    };
}
export function bridgeSupports(capability) {
    const bridge = getEventBridge();
    return !!bridge && bridge.getCapabilities().includes(capability);
}
export function canUseEventBridge(currentHost = getGlobalObject().location?.hostname) {
    const bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some((allowedHost) => currentHost === allowedHost || currentHost.endsWith(`.${allowedHost}`)));
}
function getEventBridgeGlobal() {
    return getGlobalObject().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map